<template>
    <div class="side-edit-content p-5">
        <strong class="title-main d-block mb-4">{{ $t('views.seller.integrations.config.edit.title') }}</strong>

        <!-- Exibe token -->
        <div :class="isInputError('update_token')" @click="removeError('update_token')">
            <strong class="title-medium">API Key</strong>
            <div class="d-flex bd-highlight">
                <div class="flex-grow-1 bd-highlight">
                    <b-form-group id="fieldset-url" label-for="input-url">
                        <b-form-input id="input-url" placeholder="Informe o API Key do Enotas" class="form-input"
                            v-model="token" trim></b-form-input>
                    </b-form-group>
                </div>
            </div>
            <span class="show-error">
                {{ showError('update_token') }}
            </span>
        </div>

    </div>
</template>

<script>

import NoteCenterIntegration from "@/services/resources/NoteCenterIntegration";

export default {
    name: "IntegrationsConfigUpdateEnotas",
    props: {
        opendEdit: {
            type: Boolean,
            required: true
        },
        loadingUpdate: {
            type: Boolean,
            required: true
        },
        editGroupLoad: {
            type: Boolean,
            required: true
        },
        integration: {
            type: Object,
            required: true,
            default: () => ({ name: 'Enotas' })
        },
        mountInputError: {
            type: Function,
            required: true
        },
        isInputError: {
            type: Function,
            required: true
        },
        sugestionRedirect: {
            type: Object,
            required: true,
            default: () => ({
                url: null,
                name: null,
            })
        },
        removeError: {
            type: Function,
            required: true
        },
        removeErrors: {
            type: Function,
            required: true
        },
        showError: {
            type: Function,
            required: true
        },
        fetchCallbacks: {
            type: Function,
            required: true
        },
    },
    data: () => ({
        token: '',
        loadingTest: false,
    }),
    methods: {
        showEditCallback(token) {

            this.removeErrors([
                'update_token'
            ]);

            this.$emit('update:opendEdit', true);
            this.$emit('update:editGroupLoad', false);
            this.$emit('update:loadingUpdate', false);
            this.token = token;
        },
        updateCallbacks() {

            this.$emit('update:loadingUpdate', true);

            NoteCenterIntegration.build().post('', {
                name: 'Enotas',
                config_integration: {
                    token: this.token
                },
                token: this.token,
                default: false
            }, { suppressErrorNotify: true })
                .then(() => {

                    this.$emit('update:opendEdit', false);
                    this.fetchCallbacks();

                    this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.update.success.message'), {
                        title: this.$t('views.seller.integrations.config.toast.update.success.title'),
                        variant: "success",
                        autoHideDelay: 5000,
                        appendToast: true,
                    });
                })
                .catch(error => {
                    this.mountInputError({
                        "token": error.response.data.error || 'API Key inválida'
                    }, 'update_');
                    this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.update.error.message'), {
                        title: this.$t('views.seller.integrations.config.toast.update.error.title'),
                        variant: "danger",
                        autoHideDelay: 5000,
                        appendToast: true,
                    });
                })
                .finally(() => {
                    this.$emit('update:loadingUpdate', false);
                });
        },
    }
}

</script>